/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    export interface SecurityGicsForm {
        GicsSelection: ModelTargetPicker;
        GicsSector: Serenity.StringEditor;
        GicsIndustryGroup: Serenity.StringEditor;
        GicsIndustry: Serenity.StringEditor;
        GicsSubIndustry: Serenity.StringEditor;
    }

    @Serenity.Decorators.registerClass()
	@Serenity.Decorators.responsive()
	@Serenity.Decorators.panel()
    export class SecurityDialog extends SiteEntityDialog<SecurityRow, any> {
        protected getFormKey() { return SecurityForm.formKey; }
        protected getIdProperty() { return SecurityRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityRow.localTextPrefix; }
		protected getNameProperty() { return SecurityRow.nameProperty; }
        protected getService() { return SecurityService.baseUrl; }

        protected form = new SecurityForm(this.idPrefix);

        constructor(options?: any) {
            super(options);

            this.form.GicsSelection.change(e => {
                SecurityDialog.gicsSetFormValues(this.form, false, null);
            });
        }

        loadEntity(entity) {
            super.loadEntity(entity);
            SecurityDialog.gicsLoadEntity(entity, this.form);
        }

        static gicsSetFormValues(form: SecurityGicsForm, missing: boolean, entity: SecurityRow) {
            var targetPath = form.GicsSelection.get_value();
            var target = !targetPath ? null : ModelTargetRow.getLookup().items.filter(x => x.ModelCode == "GICS" && x.TargetCode == targetPath)[0];

            form.GicsSector.value = missing ? entity?.GicsSector?.toString() :
                (target && target.Level >= 1 ? ((target.Code1 || "") + " - " + (target.Name1 || "")) : null);
            form.GicsIndustryGroup.value = missing ? entity?.GicsIndustryGroup?.toString() :
                (target && target.Level >= 2 ? ((target.Code2 || "") + " - " + (target.Name2 || "")) : null);
            form.GicsIndustry.value = missing ? entity?.GicsIndustry?.toString() :
                (target && target.Level >= 3 ? ((target.Code3 || "") + " - " + (target.Name3 || "")) : null);
            form.GicsSubIndustry.value = missing ? entity?.GicsSubIndustry?.toString() :
                (target && target.Level >= 4 ? ((target.Code4 || "") + " - " + (target.Name4 || "")) : null);
        }

        static gicsLoadEntity(entity: SecurityRow, form: SecurityGicsForm) {
            var target = entity.GicsSector != null ? ModelTargetRow.getLookup().items.filter(x =>
                x.ModelCode == "GICS" &&
                x.Code1 == entity.GicsSector as any &&
                x.Code2 == entity.GicsIndustryGroup as any &&
                x.Code3 == entity.GicsSector as any &&
                x.Code4 == entity.GicsSubIndustry as any)[0] : null;
             
            var targetPath = !target ? null : target.TargetCode;
            form.GicsSelection.set_value(targetPath);
            SecurityDialog.gicsSetFormValues(form, !target &&
                (entity.GicsSector != null || entity.GicsIndustryGroup != null ||
                    entity.GicsSector != null || entity.GicsSubIndustry != null), entity);
        }

        static gicsSaveEntity(entity: SecurityRow) {
            entity.GicsSector = Q.toId(Q.trimToNull((entity.GicsSector as any)?.split(' - ')[0]));
            entity.GicsIndustryGroup = Q.toId(Q.trimToNull((entity.GicsIndustryGroup as any)?.split(' - ')[0]));
            entity.GicsIndustry = Q.toId(Q.trimToNull((entity.GicsIndustry as any)?.split(' - ')[0]));
            entity.GicsSubIndustry = Q.toId(Q.trimToNull((entity.GicsSubIndustry as any)?.split(' - ')[0]));
        }

        static getTargetParent(target: ModelTargetRow, level: number) {
            if (level < 1 || !target || target.Level > 10 || target.Level < 1 || level > target.Level)
                return null;

            while (target.Level > level) {
                if (!target.TargetCode)
                    return null;

                var idx = target.TargetCode.lastIndexOf('/');
                if (idx < 0)
                    return null;

                var targetPath = target.TargetCode.substr(0, idx);
                var targetLevel = target.Level - 1;
                target = ModelTargetRow.getLookup().items.filter(x => x.ModelCode == "GICS" && x.TargetCode == targetPath && x.Level == targetLevel)[0];
                if (!target)
                    return null;
            }

            return target;
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons.push({
                cssClass: 'values-button',
                icon: 'fa-money',
                title: 'Security Values',
                onClick: () => {
                    var dlg = new SecurityValuesDialog();
					dlg.grid.securityId = this.entity.SecurityId;
					dlg.dialogTitle = 'Security Values: ' + this.entity.DisplayName;
                    dlg.dialogOpen();
                }
            });

			buttons.push({
				cssClass: 'override-button',
				icon: 'fa-ticket',
				title: 'Overrides',
				onClick: () => {
					SecurityOverrideService.List({
						EqualityFilter: {
							SecurityId: this.entityId
						},
                        Take: 1,
                        IncludeColumns: [
                            "$CheckingForExistingOverride"
                        ],
						ColumnSelection: Serenity.ColumnSelection.KeyOnly
					}, response => {
						if (response.Entities.length) {
							new SecurityOverrideDialog().loadByIdAndOpenDialog(response.Entities[0].RowId);
						}
						else {
							new SecurityOverrideDialog().loadEntityAndOpenDialog({
								SecurityId: this.entityId
							});
						}
					});
				}
			});

            buttons.push({
                cssClass: 'relationships-button',
                icon: 'fa fa-link',
                title: 'Relationships',
                onClick: () => {
                    var dlg = new SecurityRelationshipsDialog();
                    dlg.grid.securityId = this.entity.SecurityId;
                    dlg.dialogTitle = 'Security Relationships: ' + this.entity.DisplayName;
                    dlg.dialogOpen();
                }
            });

			buttons.push({
				cssClass: 'holding-button',
				icon: 'fa-building-o',
				title: 'Holdings',
				onClick: () => {
					var dlg = new SecurityHoldingDialog();
					dlg.grid.securityId = this.entity.SecurityId;
					dlg.dialogTitle = 'Security Holdings: ' + this.entity.DisplayName;
					dlg.dialogOpen();
				}
			});

			buttons.push({
				cssClass: 'history-button',
				icon: 'mdi mdi-history',
				title: 'History',
				onClick: () => {
					var dlg = new DataAudit.SingleSecurityHistoryDialog();
					dlg.grid.securityId = this.entity.SecurityId;
					dlg.dialogTitle = 'Security History: ' + this.entity.DisplayName;
					dlg.dialogOpen();
				}
            });

            buttons.push({
                cssClass: 'sources-button',
                icon: 'fa fa-search-plus',
                title: 'Sources',
                onClick: () => {
                    new SecurityMergeInspectionDialog({
                        securityId: this.entityId
                    }).dialogOpen();
                }
            });

            var cloneButton = Q.tryFirst(buttons, x => x.cssClass == "clone-button");
            if (cloneButton)
                cloneButton.onClick = () => {
                    var dlg = new SecurityInternalDialog();
                    var entity = this.getCloningEntity();
                    delete entity.SecurityId;
                    delete entity.SecurityCode;
                    dlg.loadEntityAndOpenDialog(entity);
                };

            var editButton = Q.tryFirst(buttons, x => x.cssClass == "edit-button");
            var editButtonDisabled = editButton.disabled;
            editButton.disabled = () => !this.hasExtendsFields || (typeof editButtonDisabled == "function" && !!editButtonDisabled());
            return buttons;
        }

        private hasExtendsFields: boolean;

        protected getPropertyItems() {
            var items = super.getPropertyItems();
            this.hasExtendsFields = Q.any(items, x => Q.startsWith(x.name, "ext_"));
            return items;

        }

        protected updateInterface() {
            super.updateInterface();

            this.deleteButton.hide();
            this.toolbar.findButton('clone-button').toggleClass('disabled',
                    !Q.Authorization.hasPermission("DataAdmin:SecurityInternal"))
            this.toolbar.findButton('values-button').toggle(this.isEditMode());
            this.toolbar.findButton('override-button').toggle(this.isEditMode());
			this.toolbar.findButton('holding-button').toggle(this.isEditMode());
			this.toolbar.findButton('merge-button').toggle(this.isEditMode());
            this.toolbar.findButton('history-button').toggle(this.isEditMode());
            this.toolbar.findButton('sources-button').toggle(this.isEditMode());

            this.editButton.toggle(!!this.hasExtendsFields && this.isViewMode() && this.hasSavePermission() && !this.hasPendingChanges);

        }
    }
}